/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'project-panel.generic-error.description': 'Verifique a conexão com a Internet e tente outra vez.',
  'project-panel.generic-error.title': 'Algo deu errado',
  'project-panel.project-icon-header.update-error-description': 'Não foi possível atualizar o ícone de {projectName}',
  'project-panel.project-icon-header.update-error-title': 'Algo deu errado.',
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': 'Mostrar mais campos',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': 'Mostrar menos',
  'project-panel.project-panel-header.title': 'Projeto',
  'project-panel.project-panel-tabs.about-tab-title': 'Sobre',
  'project-panel.project-panel-tabs.decisions-title': 'Decisões',
  'project-panel.project-panel-tabs.learnings-title': 'Aprendizados',
  'project-panel.project-panel-tabs.risks-title': 'Riscos',
  'project-panel.project-panel-tabs.updates-tab-title': 'Atualizações',
  'project-panel.project-title.edit-button-label': 'Editar título do projeto',
  'project-panel.project-title.update-error-description': 'Não foi possível atualizar o conteúdo de {projectName}',
  'project-panel.project-title.update-error-title': 'Algo deu errado',
  'project-panel.project-title.validation-message': 'Especifique um título para o projeto',
};
